import { useEffect, useRef } from 'react';
import { useWMS2010_R01Store } from './Store_WMS2010_R01';
import { Content_WMS2010_R01 } from './Content_WMS2010_R01';
import { SearchSection_WMS2010_R01 } from './SearchSection_WMS2010_R01';
import { Table_WMS2010_R01 } from './Table_WMS2010_R01';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore from 'src/store/useUiuxStore';

export const Container_WMS2010_R01 = () => {
    const { 
        initData, 
        activeTab, 
        tabData 
    } = useWMS2010_R01Store();

    const { setMessage } = useUiuxStore();

    const { fetchData, handleExcelClick, handleTabChange, columns, data } = Content_WMS2010_R01({
        setMessage
    });

    const gridRef = useRef<any>(null);

    // 권한 체크
    useFetchActionbarAuth('WMS2010_R01');

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onExcelClick={handleExcelClick}
                onCreateClick={() => {}}
                onDeleteClick={() => {}}
                onSaveClick={() => {}}
                onInitClick={initData}
            />
            <SearchSection_WMS2010_R01 />
            <div className="flex-1 flex">
                <div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
                    <Table_WMS2010_R01
                        gridRef={gridRef}
                        tabType={activeTab}
                        data={data}
                        columns={columns}
                        onTabChange={handleTabChange}
                    />
                </div>
            </div>
            <Message />
        </div>
    );
};
